/**
 * MS Cart Upsell Popup + Toast
 * v1 - 2026-05-04
 *
 * Logic:
 * - Klik DODAJ+ na .ms-upsell__item-btn:
 *   - Jeśli >1 enabled wariantów → popup size picker (bottom sheet w drawerze)
 *   - Jeśli 1 wariant lub brak (akcesoria) → instant add do cart
 * - Po add: refresh drawer via Section Rendering API + toast feedback
 */
(function() {
  'use strict';

  let popup, backdrop, toast, toastTimer;

  function init() {
    const drawer = document.querySelector('cart-drawer-component .cart-drawer__inner');
    if (!drawer) return false;

    document.querySelector('.ms-upsell-popup')?.remove();
    document.querySelector('.ms-upsell-popup-backdrop')?.remove();
    document.querySelector('.ms-cart-toast')?.remove();

    toast = document.createElement('div');
    toast.className = 'ms-cart-toast';
    toast.innerHTML = '<svg class="ms-cart-toast__check" viewBox="0 0 14 14" fill="none">' +
      '<path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span class="ms-cart-toast__text">Dodano do koszyka</span>';
    document.body.appendChild(toast);

    backdrop = document.createElement('div');
    backdrop.className = 'ms-upsell-popup-backdrop';
    drawer.appendChild(backdrop);

    popup = document.createElement('div');
    popup.className = 'ms-upsell-popup';
    popup.innerHTML = '<div class="ms-upsell-popup__header">' +
      '<img class="ms-upsell-popup__img" src="" alt="">' +
      '<div class="ms-upsell-popup__info">' +
      '<p class="ms-upsell-popup__title"></p>' +
      '<div class="ms-upsell-popup__price"></div>' +
      '</div>' +
      '<button class="ms-upsell-popup__close" aria-label="Zamknij">' +
      '<svg viewBox="0 0 14 14" fill="none">' +
      '<path d="M12 2L2 12M12 12L2 2" stroke="currentColor" ' +
      'stroke-width="1.5" stroke-linecap="round"/></svg></button>' +
      '</div>' +
      '<p class="ms-upsell-popup__label">Wybierz rozmiar</p>' +
      '<div class="ms-upsell-popup__sizes"></div>';
    drawer.appendChild(popup);

    backdrop.addEventListener('click', closePopup);
    popup.querySelector('.ms-upsell-popup__close').addEventListener('click', closePopup);

    bindUpsellButtons();

    const observer = new MutationObserver(() => bindUpsellButtons());
    const itemsContainer = document.querySelector('.cart-drawer__items');
    if (itemsContainer) {
      observer.observe(itemsContainer, { childList: true, subtree: true });
    }
    return true;
  }

  function showToast(msg) {
    if (!toast) return;
    toast.querySelector('.ms-cart-toast__text').textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
  }

  function closePopup() {
    popup?.classList.remove('is-open');
    backdrop?.classList.remove('is-open');
  }

  function openPopup(productData) {
    popup.querySelector('.ms-upsell-popup__img').src = productData.img;
    popup.querySelector('.ms-upsell-popup__img').alt = productData.title;
    popup.querySelector('.ms-upsell-popup__title').textContent = productData.title;
    popup.querySelector('.ms-upsell-popup__price').innerHTML = productData.priceHTML;

    const sizesWrap = popup.querySelector('.ms-upsell-popup__sizes');
    sizesWrap.innerHTML = '';
    productData.sizes.forEach(s => {
      const btn = document.createElement('button');
      btn.className = 'ms-upsell-popup__size';
      btn.textContent = s.label;
      btn.dataset.variantId = s.variantId;
      btn.disabled = s.disabled;
      btn.addEventListener('click', () =>
        addVariantToCart(btn, s.variantId, productData.title, s.label, productData.handle)
      );
      sizesWrap.appendChild(btn);
    });

    popup.classList.add('is-open');
    backdrop.classList.add('is-open');
  }

  function removeUpsellItem(handle) {
    if (!handle) return;
    const item = document.querySelector('.ms-upsell__item[data-product-handle="' + handle + '"]');
    if (!item) return;
    return new Promise(resolve => {
      item.classList.add('is-removing');
      setTimeout(() => {
        item.remove();
        resolve();
      }, 280);
    });
  }

  async function refreshCartDrawer(removedHandle) {
    try {
      // 0. Animacja zniknięcia produktu z upsell (zanim refresh)
      if (removedHandle) {
        await removeUpsellItem(removedHandle);
      }

      // 1. Section Rendering API - pobierz odświeżoną zawartość koszyka
      const sectionId = document.querySelector('cart-items-component')?.dataset?.sectionId;
      if (!sectionId) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }
      const sectionsData = await fetch('/?sections=' + sectionId).then(r => r.json()).catch(() => null);
      if (!sectionsData || !sectionsData[sectionId]) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }

      const tmp = document.createElement('div');
      tmp.innerHTML = sectionsData[sectionId];

      // 2. Wymień listę produktów
      const newTable = tmp.querySelector('.cart-items__table');
      const oldTable = document.querySelector('.cart-items__table');
      if (newTable && oldTable) {
        newTable.classList.add('is-refreshing');
        oldTable.replaceWith(newTable);
        setTimeout(() => newTable.classList.remove('is-refreshing'), 50);
      }

      // 3. Wymień cart bubble (licznik w headerze)
      const newBubble = tmp.querySelector('.cart-bubble');
      const oldBubble = document.querySelector('.cart-bubble');
      if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);

      // 4. Wymień shipping bar (pasek darmowej dostawy)
      const newShipping = tmp.querySelector('.ms-shipping-bar');
      const oldShipping = document.querySelector('.ms-shipping-bar');
      if (newShipping && oldShipping) oldShipping.replaceWith(newShipping);

      // 5. Update ceny w przycisku checkout
      const priceEl = document.getElementById('ms-checkout-price');
      if (priceEl) {
        const cart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
        if (cart && cart.total_price !== undefined) {
          priceEl.textContent = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' zł';
        }
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch(e) {
      console.error('[MS] Cart refresh failed:', e);
    }
  }

  // Sync upsell DOM with actual cart state (single source of truth: /cart.js)
  // Removes orphan items, clears stale snapshot, hides empty wrapper.
  async function syncUpsellWithCart() {
    try {
      const cart = await fetch('/cart.js', {cache: 'no-store'}).then(r => r.json());
      const cartHandles = new Set(cart.items.map(i => i.handle));
      const container = document.getElementById('ms-upsell-items');
      const wrapper = document.getElementById('ms-upsell');
      if (!container || !wrapper) return;

      Array.from(container.children).forEach(item => {
        const handle = item.dataset.productHandle;
        const isOrphan = item.classList.contains('is-removing');
        if ((handle && cartHandles.has(handle)) || isOrphan) {
          item.remove();
        }
      });

      if (container.children.length === 0) {
        wrapper.style.display = 'none';
      }

      window._upsellSnapshot = container.innerHTML;
    } catch(e) {
      console.warn('[upsell] sync failed', e);
    }
  }

  async function addVariantToCart(btn, variantId, productTitle, sizeLabel, productHandle) {
    btn.classList.add('is-loading');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript'
        },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('Add failed');

      closePopup();
      showToast('✓ Dodano: ' + productTitle + ' · ' + sizeLabel);
      await refreshCartDrawer(productHandle);
      // Wait for Section Rendering API to settle, then sync
      setTimeout(syncUpsellWithCart, 400);
    } catch(e) {
      btn.classList.remove('is-loading');
      showToast('Błąd - spróbuj ponownie');
      console.error('[MS] Add to cart error:', e);
    }
  }

  async function addSingleVariant(variantId, productTitle, productHandle) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('Add failed');

      showToast('✓ Dodano: ' + productTitle);
      await refreshCartDrawer(productHandle);
    } catch(e) {
      showToast('Błąd - spróbuj ponownie');
      console.error('[MS] Add to cart error:', e);
    }
  }

  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function bindUpsellButtons() {
    document.querySelectorAll('.ms-upsell__item').forEach(item => {
      const btn = item.querySelector('.ms-upsell__item-btn');
      if (!btn || btn.dataset.msBound) return;
      btn.dataset.msBound = '1';

      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const handle = btn.dataset.productHandle;
        const sizesEl = item.querySelector('.ms-upsell__sizes');
        const sizes = Array.from(sizesEl?.querySelectorAll('.ms-upsell__size-btn') || [])
          .map(b => ({
            label: b.textContent.trim(),
            variantId: b.dataset.variantId,
            disabled: b.hasAttribute('disabled'),
          }));

        if (sizes.length === 0) {
          try {
            const p = await (await fetch('/products/' + handle + '.js')).json();
            if (p.variants.length === 1) {
              addSingleVariant(p.variants[0].id, p.title, handle);
            } else {
              const popupData = {
                img: item.querySelector('img')?.src || p.featured_image,
                title: p.title,
                handle: handle,
                priceHTML: '<span>' + formatPrice(p.price) + '</span>' +
                  (p.compare_at_price > p.price
                    ? ' <s>' + formatPrice(p.compare_at_price) + '</s>'
                    : ''),
                sizes: p.variants.map(v => ({
                  label: v.options[v.options.length - 1] || v.title,
                  variantId: v.id,
                  disabled: !v.available,
                })),
              };
              openPopup(popupData);
            }
          } catch(err) {
            console.error('[MS] Product fetch failed:', err);
            window.location.href = '/products/' + handle;
          }
          return;
        }

        if (sizes.length === 1) {
          const variant = sizes[0];
          const title = item.querySelector('.ms-upsell__item-name')?.textContent?.trim()
                     || handle;
          if (!variant.disabled) {
            addSingleVariant(variant.variantId, title, handle);
          }
          return;
        }

        const title = item.querySelector('.ms-upsell__item-name')?.textContent?.trim()
                   || handle;
        const priceHTML = item.querySelector('.ms-upsell__item-price')?.innerHTML || '';
        const img = item.querySelector('img')?.src || '';
        openPopup({ img, title, priceHTML, sizes, handle });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-testid="cart-drawer-trigger"]')) {
      setTimeout(init, 300);
    }
  });
})();
